export default "__VITE_ASSET__1ff1ef09__"